import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const client = axios.create({ baseURL: BASE });

export const api = {
  bootstrap: () => client.get("/bootstrap").then((r) => r.data),
  cases: () => client.get("/cases").then((r) => r.data),
  integrations: () => client.get("/integrations").then((r) => r.data),
  dashboard: () => client.get("/dashboard").then((r) => r.data),
  analytics: () => client.get("/analytics").then((r) => r.data),

  policies: () => client.get("/policies").then((r) => r.data),
  policy: (id) => client.get(`/policies/${id}`).then((r) => r.data),
  createPolicyVersion: (id, body) => client.post(`/policies/${id}/versions`, body).then((r) => r.data),

  orders: () => client.get("/orders").then((r) => r.data),
  order: (id) => client.get(`/orders/${id}`).then((r) => r.data),
  createOrder: (body) => client.post("/orders", body).then((r) => r.data),
  evaluate: (id, body) => client.post(`/orders/${id}/evaluate`, body).then((r) => r.data),
  clarify: (id, body) => client.post(`/orders/${id}/clarification`, body).then((r) => r.data),
  addDocument: (id, body) => client.post(`/orders/${id}/documents`, body).then((r) => r.data),
  routeReview: (id, body) => client.post(`/orders/${id}/review`, body).then((r) => r.data),
  generatePacket: (id, body) => client.post(`/orders/${id}/defense-packet`, body).then((r) => r.data),

  // 0.1.1 order workflow
  evidenceChecklist: (id) => client.get(`/orders/${id}/evidence-checklist`).then((r) => r.data),
  release: (id, body) => client.post(`/orders/${id}/release`, body).then((r) => r.data),
  markRisk: (id, body) => client.post(`/orders/${id}/mark-risk`, body).then((r) => r.data),
  priorAuth: (id, body) => client.post(`/orders/${id}/prior-auth`, body).then((r) => r.data),
  abn: (id, body) => client.post(`/orders/${id}/abn`, body).then((r) => r.data),
  prebilling: (id, body) => client.post(`/orders/${id}/prebilling`, body).then((r) => r.data),
  outcome: (id, body) => client.post(`/orders/${id}/outcome`, body).then((r) => r.data),

  reviews: () => client.get("/reviews").then((r) => r.data),
  resolveReview: (id, body) => client.post(`/reviews/${id}/resolve`, body).then((r) => r.data),

  packets: () => client.get("/defense-packets").then((r) => r.data),
  packet: (id) => client.get(`/defense-packets/${id}`).then((r) => r.data),
  exportPacketPdfUrl: (orderId, roleCode) =>
    `${BASE}/orders/${orderId}/evidence-packet.pdf${roleCode ? `?role_code=${roleCode}` : ""}`,

  audit: (orderId) => client.get("/audit", { params: orderId ? { order_id: orderId } : {} }).then((r) => r.data),

  feedback: () => client.get("/validation-feedback").then((r) => r.data),
  createFeedback: (body) => client.post("/validation-feedback", body).then((r) => r.data),
  exportFeedbackUrl: () => `${BASE}/validation-feedback/export`,

  // 0.1.1 pilot validation
  pilotConfig: () => client.get("/pilot-config").then((r) => r.data),
  capturePilotAnswer: (body) => client.post("/pilot-config/answer", body).then((r) => r.data),
  operatingModel: () => client.get("/operating-model").then((r) => r.data),
  workflowStages: () => client.get("/workflow-stages").then((r) => r.data),
  integrationContracts: () => client.get("/integration-contracts").then((r) => r.data),
  futureTestAreas: () => client.get("/future-test-areas").then((r) => r.data),
  domainQuestions: () => client.get("/domain-questions").then((r) => r.data),
  answerDomainQuestion: (body) => client.post("/domain-questions/answer", body).then((r) => r.data),
  pilotReadiness: () => client.get("/pilot-readiness").then((r) => r.data),
  setReadinessItem: (body) => client.post("/pilot-readiness/item", body).then((r) => r.data),

  // Pilot validation foundations
  getSettings: () => client.get("/settings").then((r) => r.data),
  setOperatingMode: (body) => client.post("/settings/operating-mode", body).then((r) => r.data),
  shadowObservation: (id, body) => client.post(`/orders/${id}/shadow-observation`, body).then((r) => r.data),
  decisionReplay: (id) => client.get(`/orders/${id}/decision-replay`).then((r) => r.data),
  governedRules: () => client.get("/governed-rules").then((r) => r.data),
  createGovernedRule: (body) => client.post("/governed-rules", body).then((r) => r.data),
  transitionGovernedRule: (id, body) => client.post(`/governed-rules/${id}/transition`, body).then((r) => r.data),
  harnessSample: () => client.get("/rules-harness/sample").then((r) => r.data),
  runHarness: (body) => client.post("/rules-harness/run", body).then((r) => r.data),
  integrationArchitecture: () => client.get("/integration-architecture").then((r) => r.data),
  pilotMeasurement: () => client.get("/pilot-measurement").then((r) => r.data),
  denialTaxonomy: () => client.get("/denial-taxonomy").then((r) => r.data),
  assumptions: () => client.get("/assumptions").then((r) => r.data),
};

export default api;
